export default function (context) {
    context.state.error = false;
    context.state.errorText = '';
    context.state.load = false;
    context.state.dataUploaded = false;
    context.dispatch('get_list');
}